import { Stack, Typography } from "@mui/material"

type OwnProps = {
    label: string
    value: number
    units: string
}
export const QuantityItem = ({
    label,
    value,
    units
}: OwnProps) => {
    return <Stack direction={'row'} gap={1}>
        <Typography variant="caption" color={'text.disabled'}>{label}</Typography>
        <Typography variant="caption" color={'primary.main'}>{`${value} ${units}`}</Typography>
    </Stack>
}